export default "__VITE_ASSET__14547011__"